import { WorkingolfPageQuery, WORKINGOLF_QUERY } from '@layouts/workingolf'
import { fetchSSRData } from '@lib/ssr-fetch'

function WorkInGolfPage(props) {
  return (
    <WorkingolfPageQuery {...props} />
  )
}

WorkInGolfPage.getInitialProps = async ({ query }) => {
  const result = await fetchSSRData({
    query,
    graphqlQuery: WORKINGOLF_QUERY,
    variables: query,
    transform: (data) => data?.workInGolfCollection?.items?.[0],
  })
  return { ...result, ssrData: result.data }
}

export default WorkInGolfPage
